import React, { useCallback, useEffect, useState } from 'react'
import { useQuill } from 'react-quilljs'
import 'quill/dist/quill.snow.css'
import { useIntl } from 'react-intl'
import { marked } from 'marked'

export const Quill = ({
  setQuillText,
  quillText,
  formik,
  templateData,
  emailData,
  aiEmailResponse,
  isError = false,
  setPlainText,
  isDisabled = false,
  height,
  heightContainer,
  isCompanyProfile = false,
  isUsp = false,
}: {
  quillText?: string
  setQuillText?: any
  formik?: any
  templateData?: any
  emailData?: any
  aiEmailResponse?: any
  isError?: boolean
  setPlainText?: any
  isDisabled?: boolean
  height?: any
  heightContainer?: any
  isCompanyProfile?: boolean
  isUsp?: boolean
}) => {
  const [error, setError] = useState(false)
  const { formatMessage } = useIntl()
  const theme = 'snow'
  const modules = {
    toolbar: [
      [{ header: '1' }, { header: '2' }, { font: [] }],
      [{ size: [] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
      ['link', 'image', 'video'],
      ['clean'],
    ],
  }

  const placeholder = ''

  const formats = [
    'header',
    'font',
    'size',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
    'video',
  ]

  const { quill, quillRef } = useQuill({
    theme,
    modules,
    formats,
    placeholder,
    readOnly: isDisabled ? isDisabled : false,
  })

  const insertCustomText = useCallback(() => {
    const range = quill?.getSelection()
    quill?.insertText(range!.index, 'Custom text')
    quill?.setSelection(range!.index + 1, 0)
  }, [quill])

  useEffect(() => {
    if (quill && templateData?.body) {
      quill.root.innerHTML = templateData?.body
    }
    if (quill && emailData?.email?.body) {
      quill.root.innerHTML = emailData?.email?.body
    }
  }, [quill, templateData?.body]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const processMarkdown = async () => {
      if (quill && aiEmailResponse) {
        const markdownContent = aiEmailResponse
          .replace(/---/g, '')
          .replace(/\\n/g, '\n')
          .replace(/##/g, '\n ##')
        const htmlContent = await marked(markdownContent)
        quill.clipboard.dangerouslyPasteHTML(htmlContent)
        if (setPlainText) {
          setPlainText(quill.getText())
        }
      }
    }

    processMarkdown()
  }, [quill, aiEmailResponse]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (quill) {
      quill.on('text-change', () => {
        setQuillText(quill.root.innerHTML)
        if (setPlainText) {
          setPlainText(quill.getText())
        }
        if (formik && !isCompanyProfile) {
          formik.setFieldValue('quillText', quill.root.innerHTML)
        }
        if (formik && isCompanyProfile) {
          formik.setFieldValue('problemStatement', quill.root.innerHTML)
        }

        if (formik && isUsp) {
          formik.setFieldValue('USP', quill.root.innerHTML)
        }
        if (formik && isUsp) {
          formik.setFieldValue('USP', quill.root.innerHTML)
        }

        if (isError && (!quill.root.innerHTML || quill.root.innerHTML === '<p><br></p>')) {
          setError(true)
        } else {
          setError(false)
        }
      })
    }
  }, [quill, insertCustomText, formik, setQuillText, quillText, isError]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (quill) {
      quill.enable(!isDisabled)
    }
  }, [quill, isDisabled]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (quill && quillText !== undefined && quill.root.innerHTML !== quillText) {
      quill.root.innerHTML = quillText
    }
  }, [quillText, quill])


  return (
    <div style={{ width: '100%', height: heightContainer }}>
      <div
        ref={quillRef}
        style={{ minHeight: height ? `${height}px` : '200px', border: error ? '1px solid red' : '' }}
      />
      {error && <div style={{ color: 'red' }}> {formatMessage({ id: 'Value is required' })}</div>}
    </div>
  )
}
